import { render } from "./APieChart.vue?vue&type=template&id=3122d3da&scoped=true"
import script from "./APieChart.vue?vue&type=script&lang=js"
export * from "./APieChart.vue?vue&type=script&lang=js"

import "./APieChart.vue?vue&type=style&index=0&id=3122d3da&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3122d3da"]])

export default __exports__